import { Component, OnInit } from '@angular/core';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ProdutoEtapaModalidade } from '../../../models/produto-etapa-modalidade.model';
import { ProdutoEtapaModalidadeService } from '../../../services/produto-etapa-modalidade.service';
import { ActivatedRoute } from '@angular/router';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-produto-etapa-modalidade-edit',
  templateUrl: './produto-etapa-modalidade-edit.component.html',
  styleUrls: ['./produto-etapa-modalidade-edit.component.scss'],
})
export class ProdutoEtapaModalidadeEditComponent
  extends BaseFormComponent<ProdutoEtapaModalidade>
  implements OnInit
{
  actionLabel: string = 'Novo';

  constructor(
    private myService: ProdutoEtapaModalidadeService,
    public activatedRoute: ActivatedRoute,
    private navigation: NavigationService
  ) {
    super(activatedRoute);
  }

  ngOnInit(): void {
    this.loaded();
    this.initForm();
  }

  initForm() {
    this.form = new FormGroup({
      name: new FormControl('', [
        Validators.required,
        Validators.maxLength(255),
      ]),
    });

    if (this.entity) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);
    }
  }

  voltar() {
    this.navigation.back(['pre-projeto/admin/produto-etapa-modalidade']);
  }

  getDataCreate(): ProdutoEtapaModalidade {
    let data: ProdutoEtapaModalidade;
    data = Object.assign({}, data, this.form.value);
    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      if (this.entity?.id) {
        this.addSub(
          this.myService
            .update(this.getDataCreate(), this.entity?.id)
            .subscribe({
              next: (res: ProdutoEtapaModalidade) => {
                this.msgSuccess('Cadastro alterado com sucesso!');
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error.message);
                this.loaded();
              },
            })
        );
      } else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res: ProdutoEtapaModalidade) => {
              this.msgSuccess('Cadastro criado com sucesso!');
              this.navigation.replace([
                'pre-projeto/admin/produto-etapa-modalidade/',
                res.id,
              ]);
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error.message);
              this.loaded();
            },
          })
        );
      }
    } else {
      this.markAsDirty();
    }
  }
}
